// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive Layout Styles */
.responsive-layout {
  min-height: 100vh;
}

/* Sider Styles */
.layout-sider {
  background: linear-gradient(180deg, #4f46e5 0%, #7c3aed 50%, #667eea 100%) !important;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.layout-sider .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
}

/* Logo Section */
.layout-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  margin: 16px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  gap: 12px;
  min-height: 64px;
}

.logo-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.logo-image:hover {
  transform: scale(1.1);
  border-color: rgba(255, 255, 255, 0.6);
}

.logo-text {
  color: white;
  font-size: 18px;
  font-weight: 700;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
}

/* Menu Styles */
.layout-menu {
  background: transparent !important;
  border: none !important;
  flex: 1 1;
}

.layout-menu .ant-menu-item {
  background: transparent !important;
  color: rgba(255, 255, 255, 0.85) !important;
  margin: 4px 8px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  height: 48px !important;
  line-height: 48px !important;
}

.layout-menu .ant-menu-item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  transform: translateX(4px);
}

.layout-menu .ant-menu-item-selected {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.layout-menu .ant-menu-item-selected::after {
  display: none !important;
}

.layout-menu .anticon {
  font-size: 16px;
  color: inherit !important;
}

/* Header Styles */
.layout-header {
  background: white;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 999;
  height: 64px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.collapse-btn {
  color: #4f46e5 !important;
  border: none !important;
  background: transparent !important;
  font-size: 18px;
  height: 40px;
  width: 40px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.collapse-btn:hover {
  background: rgba(79, 70, 229, 0.1) !important;
  color: #4f46e5 !important;
}

.header-icon {
  color: #4f46e5;
  font-size: 24px;
}

.header-title {
  color: #333;
  font-size: 18px;
  font-weight: 600;
  display: none;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.user-info:hover {
  background: rgba(79, 70, 229, 0.1);
}

.user-name {
  color: #333;
  font-weight: 500;
}

/* Content Styles */
.layout-content {
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
  overflow: auto;
}

.content-wrapper {
  padding: 0px;
  background: white;
  margin: 0px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-height: calc(100vh - 128px);
}

/* Responsive Breakpoints */
@media (max-width: 1200px) {
  .header-title {
    display: none;
  }
  
  .content-wrapper {
    margin: 0px;
    padding: 0px;
  }
}

@media (max-width: 768px) {
  .layout-header {
    padding: 0 16px;
  }
  
  .header-left {
    gap: 8px;
  }
  
  .user-name {
    display: none;
  }
  
  .content-wrapper {
    margin: 4px;
    padding: 12px;
    border-radius: 8px;
  }
  
  .layout-logo {
    padding: 12px;
    margin: 8px 4px;
  }
  
  .logo-image {
    width: 32px;
    height: 32px;
  }
  
  .logo-text {
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .layout-header {
    padding: 0 12px;
  }
  
  .header-title {
    display: none;
  }
  
  .content-wrapper {
    margin: 2px;
    padding: 8px;
  }
}

/* Mobile Overlay */
@media (max-width: 768px) {
  .layout-sider {
    position: fixed !important;
    z-index: 1001 !important;
  }
  
  .ant-layout-sider-collapsed {
    width: 0 !important;
    min-width: 0 !important;
    max-width: 0 !important;
  }
  
  .responsive-layout .ant-layout {
    margin-left: 0 !important;
  }
}

/* Dark Theme Adjustments */
.layout-sider .ant-menu-dark {
  background: transparent;
}

.layout-sider .ant-menu-dark .ant-menu-item-selected {
  background-color: rgba(255, 255, 255, 0.2);
}

/* Animation Enhancements */
.layout-menu .ant-menu-item {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.layout-sider {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Scrollbar Styling */
.layout-sider::-webkit-scrollbar {
  width: 4px;
}

.layout-sider::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

.layout-sider::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.layout-sider::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Focus States */
.collapse-btn:focus,
.user-info:focus {
  outline: 2px solid #4f46e5;
  outline-offset: 2px;
}

/* Loading State */
.content-wrapper.loading {
  opacity: 0.7;
  pointer-events: none;
}

/* Print Styles */
@media print {
  .layout-sider,
  .layout-header {
    display: none !important;
  }
  
  .responsive-layout .ant-layout {
    margin-left: 0 !important;
  }
  
  .content-wrapper {
    margin: 0;
    padding: 0;
    box-shadow: none;
    border-radius: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ResponsiveLayout.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,qFAAqF;EACrF,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,iDAAiD;EACjD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,kCAAkC;EAClC,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":["/* Responsive Layout Styles */\r\n.responsive-layout {\r\n  min-height: 100vh;\r\n}\r\n\r\n/* Sider Styles */\r\n.layout-sider {\r\n  background: linear-gradient(180deg, #4f46e5 0%, #7c3aed 50%, #667eea 100%) !important;\r\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.layout-sider .ant-layout-sider-children {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* Logo Section */\r\n.layout-logo {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px;\r\n  margin: 16px 8px;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\r\n  gap: 12px;\r\n  min-height: 64px;\r\n}\r\n\r\n.logo-image {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  border: 2px solid rgba(255, 255, 255, 0.3);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.logo-image:hover {\r\n  transform: scale(1.1);\r\n  border-color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.logo-text {\r\n  color: white;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n/* Menu Styles */\r\n.layout-menu {\r\n  background: transparent !important;\r\n  border: none !important;\r\n  flex: 1;\r\n}\r\n\r\n.layout-menu .ant-menu-item {\r\n  background: transparent !important;\r\n  color: rgba(255, 255, 255, 0.85) !important;\r\n  margin: 4px 8px !important;\r\n  border-radius: 8px !important;\r\n  transition: all 0.3s ease !important;\r\n  height: 48px !important;\r\n  line-height: 48px !important;\r\n}\r\n\r\n.layout-menu .ant-menu-item:hover {\r\n  background: rgba(255, 255, 255, 0.1) !important;\r\n  color: white !important;\r\n  transform: translateX(4px);\r\n}\r\n\r\n.layout-menu .ant-menu-item-selected {\r\n  background: rgba(255, 255, 255, 0.2) !important;\r\n  color: white !important;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.layout-menu .ant-menu-item-selected::after {\r\n  display: none !important;\r\n}\r\n\r\n.layout-menu .anticon {\r\n  font-size: 16px;\r\n  color: inherit !important;\r\n}\r\n\r\n/* Header Styles */\r\n.layout-header {\r\n  background: white;\r\n  padding: 0 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 999;\r\n  height: 64px;\r\n}\r\n\r\n.header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.collapse-btn {\r\n  color: #4f46e5 !important;\r\n  border: none !important;\r\n  background: transparent !important;\r\n  font-size: 18px;\r\n  height: 40px;\r\n  width: 40px;\r\n  border-radius: 8px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.collapse-btn:hover {\r\n  background: rgba(79, 70, 229, 0.1) !important;\r\n  color: #4f46e5 !important;\r\n}\r\n\r\n.header-icon {\r\n  color: #4f46e5;\r\n  font-size: 24px;\r\n}\r\n\r\n.header-title {\r\n  color: #333;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  display: none;\r\n}\r\n\r\n.header-right {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.user-info {\r\n  cursor: pointer;\r\n  padding: 8px 12px;\r\n  border-radius: 8px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.user-info:hover {\r\n  background: rgba(79, 70, 229, 0.1);\r\n}\r\n\r\n.user-name {\r\n  color: #333;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Content Styles */\r\n.layout-content {\r\n  background: #f5f5f5;\r\n  min-height: calc(100vh - 64px);\r\n  overflow: auto;\r\n}\r\n\r\n.content-wrapper {\r\n  padding: 0px;\r\n  background: white;\r\n  margin: 0px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  min-height: calc(100vh - 128px);\r\n}\r\n\r\n/* Responsive Breakpoints */\r\n@media (max-width: 1200px) {\r\n  .header-title {\r\n    display: none;\r\n  }\r\n  \r\n  .content-wrapper {\r\n    margin: 0px;\r\n    padding: 0px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .layout-header {\r\n    padding: 0 16px;\r\n  }\r\n  \r\n  .header-left {\r\n    gap: 8px;\r\n  }\r\n  \r\n  .user-name {\r\n    display: none;\r\n  }\r\n  \r\n  .content-wrapper {\r\n    margin: 4px;\r\n    padding: 12px;\r\n    border-radius: 8px;\r\n  }\r\n  \r\n  .layout-logo {\r\n    padding: 12px;\r\n    margin: 8px 4px;\r\n  }\r\n  \r\n  .logo-image {\r\n    width: 32px;\r\n    height: 32px;\r\n  }\r\n  \r\n  .logo-text {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .layout-header {\r\n    padding: 0 12px;\r\n  }\r\n  \r\n  .header-title {\r\n    display: none;\r\n  }\r\n  \r\n  .content-wrapper {\r\n    margin: 2px;\r\n    padding: 8px;\r\n  }\r\n}\r\n\r\n/* Mobile Overlay */\r\n@media (max-width: 768px) {\r\n  .layout-sider {\r\n    position: fixed !important;\r\n    z-index: 1001 !important;\r\n  }\r\n  \r\n  .ant-layout-sider-collapsed {\r\n    width: 0 !important;\r\n    min-width: 0 !important;\r\n    max-width: 0 !important;\r\n  }\r\n  \r\n  .responsive-layout .ant-layout {\r\n    margin-left: 0 !important;\r\n  }\r\n}\r\n\r\n/* Dark Theme Adjustments */\r\n.layout-sider .ant-menu-dark {\r\n  background: transparent;\r\n}\r\n\r\n.layout-sider .ant-menu-dark .ant-menu-item-selected {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n/* Animation Enhancements */\r\n.layout-menu .ant-menu-item {\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.layout-sider {\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n/* Scrollbar Styling */\r\n.layout-sider::-webkit-scrollbar {\r\n  width: 4px;\r\n}\r\n\r\n.layout-sider::-webkit-scrollbar-track {\r\n  background: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.layout-sider::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border-radius: 2px;\r\n}\r\n\r\n.layout-sider::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n/* Focus States */\r\n.collapse-btn:focus,\r\n.user-info:focus {\r\n  outline: 2px solid #4f46e5;\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* Loading State */\r\n.content-wrapper.loading {\r\n  opacity: 0.7;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Print Styles */\r\n@media print {\r\n  .layout-sider,\r\n  .layout-header {\r\n    display: none !important;\r\n  }\r\n  \r\n  .responsive-layout .ant-layout {\r\n    margin-left: 0 !important;\r\n  }\r\n  \r\n  .content-wrapper {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
